import React from 'react';

import ProcurementApprovalsIndex from '../../procurement_approvals/ProcurementApprovalsIndex';
import { useProcurement } from '../context/ProcurementContext';

const ProcurementApprovalsTab = () => {
    const { routes, settings } = useProcurement();

    return (
        <ProcurementApprovalsIndex
            fetchUrl={routes.fetchProcurementKanbanBoardDataUrl}
            fetchProcurementPlanItemUrl={routes.fetchProcurementPlanItemUrl}
            downloadProcurementPlanItemAttachmentUrl={routes.downloadProcurementPlanItemAttachmentUrl}
            listUsersUrl={routes.listUsersUrl}
            groups={settings.groups}
            users={settings.users}
            departments={settings.departments}
        />
    );
};

export default ProcurementApprovalsTab;
